import NewShiftPage from "@/components/screens/shift/new";

export default function NewShift() {
  return <NewShiftPage />;
}
